// AppContext.js (React Web version)
import React, { createContext, useState, useEffect } from "react";

export const AppContext = createContext();
const STORAGE_KEY = "university_shortlist";

export const AppProvider = ({ children }) => {
  // 🎨 Theme colors
  const [backcol, setbackcol] = useState("#FFFFFF");
  const [texcol, setexcol] = useState("#000000");
  const [greycol, setgreycol] = useState("#F8F4F4");

  // 🏫 University shortlist
  const [UniList, setUniList] = useState([]);

  // ✅ Load from localStorage
  useEffect(() => {
    try {
      const storedBack = localStorage.getItem("backcolor");
      const storedText = localStorage.getItem("textcolor");
      const storedGrey = localStorage.getItem("greycolor");

      if (storedBack && storedText && storedGrey) {
        setbackcol(storedBack);
        setexcol(storedText);
        setgreycol(storedGrey);
      }

      const storedList = localStorage.getItem(STORAGE_KEY);
      if (storedList) {
        setUniList(JSON.parse(storedList));
      }
    } catch (error) {
      console.error("Error loading from localStorage:", error);
    }
  }, []);

  // 💾 Save UniList
  const saveUniList = (newUniList) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(newUniList));
      setUniList(newUniList);
    } catch (error) {
      console.error("Error saving UniList:", error);
    }
  };

  // ➕ Add new number (demo function)
  const addNumber = () => {
    const next = UniList.length + 1;
    const updated = [...UniList, next];
    saveUniList(updated);
  };

  // 💾 Save colors
  const saveColor = (newColor, newtcolor, gcolor) => {
    try {
      localStorage.setItem("backcolor", newColor);
      setbackcol(newColor);
      localStorage.setItem("textcolor", newtcolor);
      setexcol(newtcolor);
      localStorage.setItem("greycolor", gcolor);
      setgreycol(gcolor);
    } catch (error) {
      console.error("Failed to save color:", error);
    }
  };

  // 🧠 Other app-wide states
  const [uninumber, setuninumber] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const [uniname, setuniname] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedStates, setSelectedStates] = useState([]);

  const [pickedstates, setpickedstates] = useState([
    { label: "Alabama", value: "Alabama" },
    { label: "Alaska", value: "Alaska" },
    { label: "Arizona", value: "Arizona" },
    { label: "Arkansas", value: "Arkansas" },
    { label: "California", value: "California" },
    { label: "Colorado", value: "Colorado" },
    { label: "Connecticut", value: "Connecticut" },
    { label: "Delaware", value: "Delaware" },
    { label: "Florida", value: "Florida" },
    { label: "Georgia", value: "Georgia" },
    { label: "Hawaii", value: "Hawaii" },
    { label: "Idaho", value: "Idaho" },
    { label: "Illinois", value: "Illinois" },
    { label: "Indiana", value: "Indiana" },
    { label: "Iowa", value: "Iowa" },
    { label: "Kansas", value: "Kansas" },
    { label: "Kentucky", value: "Kentucky" },
    { label: "Louisiana", value: "Louisiana" },
    { label: "Maine", value: "Maine" },
    { label: "Maryland", value: "Maryland" },
    { label: "Massachusetts", value: "Massachusetts" },
    { label: "Michigan", value: "Michigan" },
    { label: "Minnesota", value: "Minnesota" },
    { label: "Mississippi", value: "Mississippi" },
    { label: "Missouri", value: "Missouri" },
    { label: "Montana", value: "Montana" },
    { label: "Nebraska", value: "Nebraska" },
    { label: "Nevada", value: "Nevada" },
    { label: "New Hampshire", value: "New Hampshire" },
    { label: "New Jersey", value: "New Jersey" },
    { label: "New Mexico", value: "New Mexico" },
    { label: "New York", value: "New York" },
    { label: "North Carolina", value: "North Carolina" },
    { label: "North Dakota", value: "North Dakota" },
    { label: "Ohio", value: "Ohio" },
    { label: "Oklahoma", value: "Oklahoma" },
    { label: "Oregon", value: "Oregon" },
    { label: "Pennsylvania", value: "Pennsylvania" },
    { label: "Rhode Island", value: "Rhode Island" },
    { label: "South Carolina", value: "South Carolina" },
    { label: "South Dakota", value: "South Dakota" },
    { label: "Tennessee", value: "Tennessee" },
    { label: "Texas", value: "Texas" },
    { label: "Utah", value: "Utah" },
    { label: "Vermont", value: "Vermont" },
    { label: "Virginia", value: "Virginia" },
    { label: "Washington", value: "Washington" },
    { label: "Washington, DC", value: "Washington, DC" },
    { label: "West Virginia", value: "West Virginia" },
    { label: "Wisconsin", value: "Wisconsin" },
    { label: "Wyoming", value: "Wyoming" },
  ]);

  const [csscheckbox, setcsscheckbox] = useState(false);
  const [rollingcheckbox, setrollingcheckbox] = useState(false);
  const [tutionmin, settutionmin] = useState(0);
  const [tuitionmax, settuitionmax] = useState(150000);
  const [maximumaccept, setmaximumaccept] = useState(100);
  const [minimumaccept, setminimumaccept] = useState(0);
  const [currentSort, setCurrentSort] = useState("None");
    const logos = {
  superman: require('./Logos/superman.png'),
  caltech: require('./Logos/caltech.png'),
  harvard: require('./Logos/harvard.png'),
  Berkley: require('./Logos/Berkley.png'),
  chicago: require('./Logos/chicago.png'),
  Columbia: require('./Logos/Columbia.jpg'),
  pennyslavania: require('./Logos/pennyslavania.png'),
  princeton: require('./Logos/princeton.png'),
  stanford: require('./Logos/stanford.png'),
  Bastyr: require('./Logos/Bastyr.png'),
  Cornish: require('./Logos/Cornish.png'),
  CUS: require('./Logos/CUS.jpg'),
  CWU: require('./Logos/CWU.png'),
  EastWash: require('./Logos/EastWash.png'),
  Evergreen: require('./Logos/Evergreen.jpg'),
  Gonzaga: require('./Logos/Gonzaga.jpg'),
  Heritage: require('./Logos/Heritage.jpg'),
  Northindian: require('./Logos/Northindian.png'),
  Northwash: require('./Logos/Northwash.png'),
  PaciLu: require('./Logos/PaciLu.jpg'),
  PugetSound: require('./Logos/PugetSound.jpg'),
  SaintMartin: require('./Logos/SaintMartin.png'),
  SeattlePaci: require('./Logos/SeattlePaci.png'),
  SeattleU: require('./Logos/SeattleU.png'),
  UBothel: require('./Logos/UBothel.png'),
  UWashington: require('./Logos/UWashington.png'),
  WallaWalla: require('./Logos/WallaWalla.png'),
  WashState: require('./Logos/WashState.jpg'),
  Washtricity: require('./Logos/Washtricity.png'),
  Washvanco: require('./Logos/Washvanco.png'),
  Westgov: require('./Logos/Westgov.png'),
  WestWu: require('./Logos/WestWu.png'),
  Whitman: require('./Logos/Whitman.png'),
  Whitworth: require('./Logos/Whitworth.png'),
  WTacoma: require('./Logos/WTacoma.jpg'),
  Angeloregon: require('./Logos/Angeloregon.jpg'),
  Bushnell: require('./Logos/Bushnell.png'),
  Corban: require('./Logos/Corban.jpg'),
  EastOregon: require('./Logos/EastOregon.jpg'),
  GeoFox: require('./Logos/GeoFox.png'),
  Gutenberg: require('./Logos/Gutenberg.jpg'),
  Hopeoregon: require('./Logos/Hopeoregon.png'),
  Lewisoregon: require('./Logos/Lewisoregon.png'),
  Linfield: require('./Logos/Linfield.png'),
  Multonomah: require('./Logos/Multonomah.jpg'),
  oregonpacific: require('./Logos/oregonpacific.jpg'),
  Oregonscience: require('./Logos/Oregonscience.jpg'),
  oregonstate: require('./Logos/oregonstate.png'),
  Oregontech: require('./Logos/Oregontech.png'),
  pacificoregon: require('./Logos/pacificoregon.png'),
  portlandstate: require('./Logos/portlandstate.png'),
  reedoregon: require('./Logos/reedoregon.jpg'),
  southoregon: require('./Logos/southoregon.png'),
  Uoregon: require('./Logos/Uoregon.png'),
  Uportland: require('./Logos/Uportland.jpg'),
  warnerpacific: require('./Logos/warnerpacific.png'),
  westoregon: require('./Logos/westoregon.png'),
  willpatt: require('./Logos/willpatt.png'),
  williamete: require('./Logos/williamete.png'),
  angelsmusic: require('./Logos/angelsmusic.jpg'),
  redcrest: require('./Logos/redcrest.jpg'),
  artacademycali: require('./Logos/artacademycali.png'),
  artdesigncali: require('./Logos/artdesigncali.png'),
  azusapacific: require('./Logos/azusapacific.png'),
  betsheda: require('./Logos/betsheda.png'),
  biola: require('./Logos/biola.jpg'),
  calbaker: require('./Logos/calbaker.png'),
  calbaptist: require('./Logos/calbaptist.png'),
  calbernard: require('./Logos/calbernard.png'),
  calchico: require('./Logos/calchico.png'),
  calcolart: require('./Logos/calcolart.png'),
  caldominos: require('./Logos/caldominos.png'),
  caleastbay: require('./Logos/caleastbay.png'),
  calfresno: require('./Logos/calfresno.png'),
  calfuller: require('./Logos/calfuller.png'),
  calhollywood: require('./Logos/calhollywood.png'),
  calilus: require('./Logos/calilus.png'),
  callongbeach: require('./Logos/callongbeach.png'),
  calluther: require('./Logos/calluther.png'),
  calmonterbay: require('./Logos/calmonterbay.png'),
  calnorthridge: require('./Logos/calnorthridge.png'),
  calpolyhumb: require('./Logos/calpolyhumb.png'),
  calpolymartime: require('./Logos/calpolymartime.png'),
  calsacra: require('./Logos/calsacra.png'),
  calsanmarcos: require('./Logos/calsanmarcos.jpg'),
  calstatela: require('./Logos/calstatela.png'),
  calypolypomo: require('./Logos/calypolypomo.png'),
  calypolysta: require('./Logos/calypolysta.jpg'),
  carlinstart: require('./Logos/carlinstart.png'),
  channelislands: require('./Logos/channelislands.png'),
  chapman: require('./Logos/chapman.png'),
  charlesmedicine: require('./Logos/charlesmedicine.jpg'),
  claremont: require('./Logos/claremont.png'),
  cogswell: require('./Logos/cogswell.png'),
  concordia: require('./Logos/concordia.png'),
  designcali: require('./Logos/designcali.jpg'),
  diegochristian: require('./Logos/diegochristian.png'),
  diegostate: require('./Logos/diegostate.png'),
  dominicancali: require('./Logos/dominicancali.png'),
  fashioncali: require('./Logos/fashioncali.png'),
  franciscostate: require('./Logos/franciscostate.jpg'),
  fresnopaci: require('./Logos/fresnopaci.png'),
  goldengate: require('./Logos/goldengate.jpg'),
  harveymudd: require('./Logos/harveymudd.png'),
  hopecali: require('./Logos/hopecali.png'),
  humpcali: require('./Logos/humpcali.png'),
  jessup: require('./Logos/jessup.png'),
  jewishcali: require('./Logos/jewishcali.png'),
  johncali: require('./Logos/johncali.jpg'),
  laguna: require('./Logos/laguna.png'),
  Lasierra: require('./Logos/Lasierra.png'),
  laverne: require('./Logos/laverne.png'),
  lifepacific: require('./Logos/lifepacific.jpg'),
  Loyolacali: require('./Logos/Loyolacali.png'),
  marycali: require('./Logos/marycali.png'),
  maryland: require('./Logos/maryland.png'),
  millscali: require('./Logos/millscali.png'),
  masters: require('./Logos/masters.png'),
  menlo: require('./Logos/menlo.png'),
  poloo: require('./Logos/poloo.png'),
  merced: require('./Logos/merced.png'),
  merrit: require('./Logos/merrit.png'),
  mountsaintca: require('./Logos/mountsaintca.jpg'),
  nationalcali: require('./Logos/nationalcali.png'),
  newschoolcali: require('./Logos/newschoolcali.png'),
  northcali: require('./Logos/northcali.png'),
  northwestpoly: require('./Logos/northwestpoly.jpg'), 
  notrecali: require('./Logos/notrecali.png'),
  occidental: require('./Logos/occidental.png'),
  otis: require('./Logos/otis.png'),
  pacificoke: require('./Logos/pacificoke.png'),
  paciunion: require('./Logos/paciunion.png'),
  patten: require('./Logos/patten.jpg'),
  pepperdine: require('./Logos/pepperdine.png'),
  pitzer: require('./Logos/pitzer.png'),
  pointloma: require('./Logos/pointloma.png'),
  ponoma: require('./Logos/ponoma.jpg'),
  redlands: require('./Logos/redlands.jpg'),
  sanjose: require('./Logos/sanjose.png'),
  santaclara: require('./Logos/santaclara.png'),
  soka: require('./Logos/soka.png'),
  scia: require('./Logos/scia.png'),
  scripps: require('./Logos/scripps.jpg'),
  sfcm: require('./Logos/sfcm.png'),
  simpson: require('./Logos/simpson.png'),
  sonoma: require('./Logos/sonoma.png'),
  ucdavis: require('./Logos/ucdavis.png'),
  ucdiego: require('./Logos/ucdiego.png'),
  ucirvine: require('./Logos/ucirvine.png'),
  ucla: require('./Logos/ucla.png'),
  ucriver: require('./Logos/ucriver.png'),
  ucsanta: require('./Logos/ucsanta.png'),
  ucsb: require('./Logos/ucsb.png'),
  upacicali: require('./Logos/upacicali.png'),
  usandiego: require('./Logos/usandiego.jpg'),
  usanfran: require('./Logos/usanfran.jpg'),
  usouthcali: require('./Logos/usouthcali.png'),
  vanguardcali: require('./Logos/vanguardcali.png'),
  westcoast: require('./Logos/westcoast.png'),
  westmont: require('./Logos/westmont.jpg'),
  whittiercollege: require('./Logos/whittiercollege.jpg'),
  woodbury: require('./Logos/woodbury.png'),
  boisebible: require('./Logos/boisebible.png'),
  boisestate: require('./Logos/boisestate.png'),
  byuid: require('./Logos/byuid.png'),
  colsounev: require('./Logos/colsounev.png'),
  greatbasin: require('./Logos/greatbasin.jpg'),
  idahocollege: require('./Logos/idahocollege.jpg'),
  idahonazar: require('./Logos/idahonazar.jpg'),
  idahostate: require('./Logos/idahostate.png'),
  lewisclark: require('./Logos/lewisclark.jpg'),
  nevadastate: require('./Logos/nevadastate.png'),
  snutan: require('./Logos/snutan.png'),
  uidaho: require('./Logos/uidaho.png'),
  unlv: require('./Logos/unlv.png'),
  unreno: require('./Logos/unreno.png'),
  bozeman: require('./Logos/bozeman.png'),
  carrol: require('./Logos/carrol.png'),
  kootenai: require('./Logos/kootenai.jpg'),
  montanabill: require('./Logos/montanabill.png'),
  montananorth: require('./Logos/montananorth.jpg'),
  montatech: require('./Logos/montatech.png'),
  montwest: require('./Logos/montwest.jpg'),
  providence: require('./Logos/providence.jpg'),
  rockymount: require('./Logos/rockymount.jpg'),
  umontana: require('./Logos/umontana.png'),
  adamstate: require('./Logos/adamstate.jpg'),
  coloboulder: require('./Logos/coloboulder.png'),
  colomines: require('./Logos/colomines.png'),
  coloradochristian: require('./Logos/coloradochristian.png'),
  coloradocolleg: require('./Logos/coloradocolleg.png'),
  coloradostate: require('./Logos/coloradostate.png'),
  coloradotechni: require('./Logos/coloradotechni.jpg'),
  csupueblo: require('./Logos/csupueblo.png'),
  cudenver: require('./Logos/cudenver.jpg'),
  fortlewis: require('./Logos/fortlewis.png'),
  mesa: require('./Logos/mesa.png'),
  msudenver: require('./Logos/msudenver.jpg'),
  neumont: require('./Logos/neumont.jpg'),
  northcolorado: require('./Logos/northcolorado.png'),
  provo: require('./Logos/provo.png'),
  regis: require('./Logos/regis.png'),
  rmcad: require('./Logos/rmcad.jpg'),
  southutah: require('./Logos/southutah.jpg'),
  uccs: require('./Logos/uccs.jpg'),
  utahstate: require('./Logos/utahstate.png'),
  utahtech: require('./Logos/utahtech.png'),
  utahvaley: require('./Logos/utahvaley.png'),
  Uutah: require('./Logos/Uutah.png'),
  uwyomin: require('./Logos/uwyomin.png'),
  weber: require('./Logos/weber.png'),
  westcolorado: require('./Logos/westcolorado.png'),
  westminister: require('./Logos/westminister.png'),
  wyocath: require('./Logos/wyocath.png'),
  aristate: require('./Logos/aristate.png'),
  arizonachrist: require('./Logos/arizonachrist.jpg'),
  benecditine: require('./Logos/benecditine.png'),
  chamberlain: require('./Logos/chamberlain.png'),
  eastmex: require('./Logos/eastmex.png'),
  erauprescott: require('./Logos/erauprescott.png'),
  grandcanyon: require('./Logos/grandcanyon.png'),
  highlands: require('./Logos/highlands.png'),
  indianart: require('./Logos/indianart.png'),
  indiancol: require('./Logos/indiancol.png'),
  mexitech: require('./Logos/mexitech.png'),
  nmstate: require('./Logos/nmstate.png'),
  northarizona: require('./Logos/northarizona.png'),
  northmex: require('./Logos/northmex.jpg'),
  prescott: require('./Logos/prescott.png'),
  southwest: require('./Logos/southwest.png'),
  stjohn: require('./Logos/stjohn.jpg'),
  uarizona: require('./Logos/uarizona.png'),
  uatech: require('./Logos/uatech.jpg'),
  Umexico: require('./Logos/Umexico.png'),
  augustana: require('./Logos/augustana.jpg'),
  bacone: require('./Logos/bacone.png'),
  baker: require('./Logos/baker.png'),
  barclay: require('./Logos/barclay.jpg'),
  bellevue: require('./Logos/bellevue.png'),
  bene: require('./Logos/bene.png'),
  bethany: require('./Logos/bethany.png'),
  bethel: require('./Logos/bethel.png'),
  blackhills: require('./Logos/blackhills.png'),
  cameron: require('./Logos/cameron.jpg'),
  centralken: require('./Logos/centralken.png'),
  chadron: require('./Logos/chadron.jpg'),
  clarkson: require('./Logos/clarkson.png'),
  clevekan: require('./Logos/clevekan.jpg'),
  colmary: require('./Logos/colmary.png'),
  connebraska: require('./Logos/connebraska.png'),
  creighton: require('./Logos/creighton.png'),
  dakotamines: require('./Logos/dakotamines.png'),
  dakotastate: require('./Logos/dakotastate.jpg'),
  dakwes: require('./Logos/dakwes.png'),
  doane: require('./Logos/doane.png'),
  eastcent: require('./Logos/eastcent.jpg'),
  emporia: require('./Logos/emporia.png'),
  forthay: require('./Logos/forthay.png'),
  friends: require('./Logos/friends.png'),
  grantham: require('./Logos/grantham.png'),
  haskell: require('./Logos/haskell.png'),
  hastings: require('./Logos/hastings.jpg'),
  jamestown: require('./Logos/jamestown.png'),
  jayhawks: require('./Logos/jayhawks.png'),
  kansasstate: require('./Logos/kansasstate.png'),
  kansaswes: require('./Logos/kansaswes.png'),
  langston: require('./Logos/langston.png'),
  lincoln: require('./Logos/lincoln.png'),
  lopers: require('./Logos/lopers.png'),
  manchrist: require('./Logos/manchrist.jpg'),
  marykan: require('./Logos/marykan.jpg'),
  mayville: require('./Logos/mayville.png'),
  mcperson: require('./Logos/mcperson.png'),
  midamerica: require('./Logos/midamerica.png'),
  midland: require('./Logos/midland.png'),
  minot: require('./Logos/minot.png'),
  mountmarty: require('./Logos/mountmarty.png'),
  ndsu: require('./Logos/ndsu.png'),
  nebraskahealth: require('./Logos/nebraskahealth.png'),
  nebrawes: require('./Logos/nebrawes.png'),
  newman: require('./Logos/newman.png'),
  northdakota: require('./Logos/northdakota.png'),
  northeaster: require('./Logos/northeaster.png'),
  northokla: require('./Logos/northokla.png'),
  oglala: require('./Logos/oglala.png'),
  oklabap: require('./Logos/oklabap.jpg'),
  oklachrist: require('./Logos/oklachrist.png'),
  oklacity: require('./Logos/oklacity.png'),
  okscience: require('./Logos/okscience.jpg'),
  okstate: require('./Logos/okstate.png'),
  okwesle: require('./Logos/okwesle.png'),
  omaha: require('./Logos/omaha.png'),
  oralrob: require('./Logos/oralrob.png'),
  ottawa: require('./Logos/ottawa.jpg'),
  panhandle: require('./Logos/panhandle.jpg'),
  peru: require('./Logos/peru.jpg'),
  pittsburg: require('./Logos/pittsburg.png'),
  randall: require('./Logos/randall.png'),
  rogers: require('./Logos/rogers.png'),
  sinte: require('./Logos/sinte.jpg'),
  cincinn: require('./Logos/cincinn.jpg'),
  sioux: require('./Logos/sioux.png'),
  sittingbull: require('./Logos/sittingbull.jpg'),
  sounaz: require('./Logos/sounaz.png'),
  sterling: require('./Logos/sterling.png'),
  swkan: require('./Logos/swkan.png'),
  swosu: require('./Logos/swosu.jpg'),
  tabor: require('./Logos/tabor.png'),
  trinitybi: require('./Logos/trinitybi.png'),
  ucokl: require('./Logos/ucokl.png'),
  Umary: require('./Logos/Umary.png'),
  unionadv: require('./Logos/unionadv.png'),
  Uoklaho: require('./Logos/Uoklaho.png'),
  Usouthdak: require('./Logos/Usouthdak.jpg'),
  valleycity: require('./Logos/valleycity.png'),
  washburn: require('./Logos/washburn.png'),
  waynesta: require('./Logos/waynesta.png'),
  westchrist: require('./Logos/westchrist.jpg'),
  wichita: require('./Logos/wichita.jpg'),
  yorkne: require('./Logos/yorkne.jpg'),
  abilene: require('./Logos/abilene.jpg'),
  amcom: require('./Logos/amcom.png'),
  angelo: require('./Logos/angelo.jpg'),
  arlington: require('./Logos/arlington.png'),
  atm: require('./Logos/atm.png'),
  austincol: require('./Logos/austincol.jpg'),
  baylor: require('./Logos/baylor.png'),
  clearlake: require('./Logos/clearlake.png'),
  concotx: require('./Logos/concotx.png'),
  corpus: require('./Logos/corpus.png'),
  criswell: require('./Logos/criswell.png'),
  dalbap: require('./Logos/dalbap.png'),
  dallchrist: require('./Logos/dallchrist.png'),
  eastbapt: require('./Logos/eastbapt.png'),
  hardsim: require('./Logos/hardsim.png'),
  houschrist: require('./Logos/houschrist.jpg'),
  howpain: require('./Logos/howpain.jpg'),
  hustill: require('./Logos/hustill.png'),
  jarvis: require('./Logos/jarvis.png'),
  kingsville: require('./Logos/kingsville.png'),
  lamar: require('./Logos/lamar.png'),
  letour: require('./Logos/letour.png'),
  lubbock: require('./Logos/lubbock.png'),
  marytx: require('./Logos/marytx.jpg'),
  mcmurry: require('./Logos/mcmurry.png'),
  midwest: require('./Logos/midwest.png'),
  nelson: require('./Logos/nelson.jpg'),
  northtx: require('./Logos/northtx.png'),
  ollu: require('./Logos/ollu.png'),
  parker: require('./Logos/parker.jpg'),
  pquinn: require('./Logos/pquinn.jpg'),
  pvamu: require('./Logos/pvamu.jpg'),
  rice: require('./Logos/rice.png'),
  riogrande: require('./Logos/riogrande.png'),
  samhu: require('./Logos/samhu.png'),
  schreiner: require('./Logos/schreiner.png'),
  sfatx: require('./Logos/sfatx.png'),
  smutx: require('./Logos/smutx.jpg'),
  stdallas: require('./Logos/stdallas.png'),
  stedwards: require('./Logos/stedwards.png'),
  stx: require('./Logos/stx.jpg'),
  sulross: require('./Logos/sulross.png'),
  swautx: require('./Logos/swautx.png'),
  swcctx: require('./Logos/swcctx.png'),
  tarleton: require('./Logos/tarleton.jpg'),
  tcutx: require('./Logos/tcutx.png'),
  techtx: require('./Logos/techtx.png'),
  texarkana: require('./Logos/texarkana.jpg'),
  texluth: require('./Logos/texluth.png'),
  trinitytx: require('./Logos/trinitytx.png'),
  tsured: require('./Logos/tsured.jpg'),
  txcolb: require('./Logos/txcolb.jpg'),
  txint: require('./Logos/txint.jpg'),
  txstate: require('./Logos/txstate.jpg'),
  tyler: require('./Logos/tyler.jpg'),
  uarlington: require('./Logos/uarlington.png'),
  uaustin: require('./Logos/uaustin.png'),
  udalas: require('./Logos/udalas.png'),
  udallas: require('./Logos/udallas.png'),
  uhdown: require('./Logos/uhdown.png'),
  Uhouston: require('./Logos/Uhouston.png'),
  uhvictoria: require('./Logos/uhvictoria.jpg'),
  umhb: require('./Logos/umhb.jpg'),
  utep: require('./Logos/utep.png'),
  utpb: require('./Logos/utpb.png'),
  utsatx: require('./Logos/utsatx.jpg'),
  wayland: require('./Logos/wayland.png'),
  wesletx: require('./Logos/wesletx.png'),
  westtx: require('./Logos/waynesta.png'),
  wiley: require('./Logos/wiley.png'),
  womantx: require('./Logos/womantx.png'),
  wordtx: require('./Logos/wordtx.png'),
  academy: require('./Logos/academy.png'),
  auggies: require('./Logos/auggies.png'),
  bemdji: require('./Logos/bemdji.jpg'),
  bethelmin: require('./Logos/bethelmin.png'),
  bethglobal: require('./Logos/bethglobal.png'),
  bethluther: require('./Logos/bethluther.png'),
  capella: require('./Logos/capella.png'),
  carleton: require('./Logos/carleton.png'),
  catherine: require('./Logos/catherine.jpg'),
  cloudstate: require('./Logos/cloudstate.png'),
  crookston: require('./Logos/crookston.png'),
  crowncoll: require('./Logos/crowncoll.png'),
  csbmin: require('./Logos/csbmin.png'),
  duluth: require('./Logos/duluth.png'),
  gustavus: require('./Logos/gustavus.jpg'),
  hamline: require('./Logos/hamline.jpg'),
  macalester: require('./Logos/macalester.png'),
  mankato: require('./Logos/mankato.png'),
  martinlu: require('./Logos/martinlu.jpg'),
  marymin: require('./Logos/marymin.png'),
  mcad: require('./Logos/mcad.png'),
  metropolitan: require('./Logos/metropolitan.png'),
  minnesota: require('./Logos/minnesota.png'),
  mintree: require('./Logos/mintree.png'),
  mohead: require('./Logos/mohead.png'),
  moorhead: require('./Logos/moorhead.jpg'),
  morris: require('./Logos/morris.png'),
  blueyy: require('./Logos/blueyy.png'),
  oakhills: require('./Logos/oakhills.jpg'),
  olaf: require('./Logos/olaf.png'),
  raptors: require('./Logos/raptors.png'),
  schola: require('./Logos/schola.png'),
  sjmin: require('./Logos/sjmin.jpg'),
  stpaul: require('./Logos/stpaul.png'),
  swmin: require('./Logos/swmin.png'),
  thomasmin: require('./Logos/thomasmin.png'),
  winona: require('./Logos/winona.jpg'),
  allenio: require('./Logos/allenio.jpg'),
  ambrose: require('./Logos/ambrose.png'),
  briar: require('./Logos/briar.png'),
  buena: require('./Logos/buena.jpg'),
  bulldogs: require('./Logos/bulldogs.png'),
  centralio: require('./Logos/centralio.png'),
  clarkeio: require('./Logos/clarkeio.png'),
  coeio: require('./Logos/coeio.jpg'),
  corniowa: require('./Logos/corniowa.png'),
  divineiow: require('./Logos/divineiow.png'),
  dordt: require('./Logos/dordt.png'),
  dubu: require('./Logos/dubu.jpg'),
  emmaus: require('./Logos/emmaus.png'),
  faithiow: require('./Logos/faithiow.png'),
  graceland: require('./Logos/graceland.png'),
  grinnell: require('./Logos/grinnell.jpg'),
  iowastate: require('./Logos/iowastate.png'),
  iowesle: require('./Logos/iowesle.png'),
  loras: require('./Logos/loras.jpg'),
  maharishi: require('./Logos/maharishi.jpg'),
  mercyio: require('./Logos/mercyio.png'),
  morningio: require('./Logos/morningio.png'),
  mountmercy: require('./Logos/mountmercy.png'),
  norse: require('./Logos/norse.png'),
  northiow: require('./Logos/northiow.png'),
  nwiow: require('./Logos/nwiow.png'),
  simpio: require('./Logos/simpio.png'),
  Uiowa: require('./Logos/Uiowa.png'),
  upperio: require('./Logos/upperio.png'),
  vikings: require('./Logos/vikings.png'),
  waldorf: require('./Logos/waldorf.jpg'),
  wartburg: require('./Logos/wartburg.png'),
  willipen: require('./Logos/willipen.jpg'),
  avila: require('./Logos/avila.png'),
  bluetiger: require('./Logos/bluetiger.png'),
  calvary: require('./Logos/calvary.png'),
  cccb: require('./Logos/cccb.jpg'),
  centralmisso: require('./Logos/centralmisso.jpg'),
  cmeagles: require('./Logos/cmeagles.jpg'),
  colicollege: require('./Logos/colicollege.png'),
  conception: require('./Logos/conception.png'),
  cottey: require('./Logos/cottey.png'),
  coxco: require('./Logos/coxco.jpg'),
  drury: require('./Logos/drury.png'),
  evangel: require('./Logos/evangel.png'),
  fontbonne: require('./Logos/fontbonne.png'),
  hannibal: require('./Logos/hannibal.png'),
  hornets: require('./Logos/hornets.png'),
  jewell: require('./Logos/jewell.png'),
  kansasart: require('./Logos/kansasart.png'),
  lidenwood: require('./Logos/lidenwood.png'),
  loganmis: require('./Logos/loganmis.png'),
  redm: require('./Logos/redm.jpg'),
  mission: require('./Logos/mission.png'),
  missost: require('./Logos/missost.png'),
  missourist: require('./Logos/missourist.jpg'),
  missovalley: require('./Logos/missovalley.jpg'),
  mslions: require('./Logos/mslions.png'),
  northmisso: require('./Logos/northmisso.png'),
  ozarkmis: require('./Logos/ozarkmis.jpg'),
  parkmiso: require('./Logos/parkmiso.png'),
  rockhurst: require('./Logos/rockhurst.png'),
  southmisso: require('./Logos/southmisso.png'),
  stephens: require('./Logos/stephens.png'),
  stlouis: require('./Logos/stlouis.png'),
  truman: require('./Logos/truman.jpg'),
  uhsp: require('./Logos/uhsp.png'),
  Umisso: require('./Logos/Umisso.png'),
  Umkc: require('./Logos/Umkc.png'),
  Umsl: require('./Logos/Umsl.jpg'),
  washst: require('./Logos/washst.png'),
  webster: require('./Logos/webster.png'),
  westbap: require('./Logos/westbap.jpg'),
  westminster: require('./Logos/westminster.png'),
  westmisso: require('./Logos/westmisso.png'),
  wildcats: require('./Logos/wildcats.png'),
  williwoods: require('./Logos/williwoods.png'),
  arkanbap: require('./Logos/arkanbap.jpg'),
  arkantech: require('./Logos/arkantech.png'),
  arkastate: require('./Logos/arkastate.png'),
  centbapt: require('./Logos/centbapt.png'),
  centralarkan: require('./Logos/centralarkan.png'),
  harding: require('./Logos/harding.png'),
  henderson: require('./Logos/henderson.jpg'),
  hendrix: require('./Logos/hendrix.png'),
  jbrown: require('./Logos/jbrown.jpg'),
  littlerock: require('./Logos/littlerock.png'),
  lyoncol: require('./Logos/lyoncol.jpg'),
  monticello: require('./Logos/monticello.jpg'),
  ouachita: require('./Logos/ouachita.png'),
  ozarksark: require('./Logos/ozarksark.png'),
  philsmith: require('./Logos/philsmith.png'),
  southarka: require('./Logos/southarka.png'),
  Uarkansas: require('./Logos/Uarkansas.png'),
  Ufortnite: require('./Logos/Ufortnite.png'),
  willibap: require('./Logos/willibap.jpg'),
  pinebluff: require('./Logos/pinebluff.jpg'),
  alexlou: require('./Logos/alexlou.jpg'),
  centenary: require('./Logos/centenary.jpg'),
  dillard: require('./Logos/dillard.jpg'),
  franciscan: require('./Logos/franciscan.png'),
  grambling: require('./Logos/grambling.png'),
  holycross: require('./Logos/holycross.png'),
  josephlou: require('./Logos/josephlou.png'),
  lafay: require('./Logos/lafay.png'),
  leavell: require('./Logos/leavell.png'),
  louischrist: require('./Logos/louischrist.jpg'),
  louistate: require('./Logos/louistate.png'),
  loutech: require('./Logos/loutech.png'),
  loyolou: require('./Logos/loyolou.jpg'),
  mcneese: require('./Logos/mcneese.png'),
  nicholls: require('./Logos/nicholls.png'),
  nwlou: require('./Logos/nwlou.png'),
  shreveport: require('./Logos/shreveport.png'),
  soulou: require('./Logos/soulou.png'),
  sulou: require('./Logos/sulou.png'),
  tulane: require('./Logos/tulane.png'),
  Uneworl: require('./Logos/Uneworl.png'),
  warhawks: require('./Logos/warhawks.jpg'),
  xavier: require('./Logos/xavier.png'),
  alverno: require('./Logos/alverno.png'),
  aurora: require('./Logos/aurora.jpg'),
  bellin: require('./Logos/bellin.jpg'),
  beloit: require('./Logos/beloit.jpg'),
  carroll: require('./Logos/carroll.png'),
  carthage: require('./Logos/carthage.jpg'),
  concowis: require('./Logos/concowis.png'),
  eauclaire: require('./Logos/eauclaire.png'),
  edgewood: require('./Logos/edgewood.jpg'),
  greenbay: require('./Logos/greenbay.png'),
  lacrosse: require('./Logos/lacrosse.jpg'),
  lakeland: require('./Logos/lakeland.png'),
  lawrence: require('./Logos/lawrence.png'),
  madison: require('./Logos/madison.png'),
  maranatha: require('./Logos/maranatha.jpg'),
  marian: require('./Logos/marian.jpg'),
  marquette: require('./Logos/marquette.png'),
  marywis: require('./Logos/marywis.jpg'),
  Miad: require('./Logos/Miad.png'),
  mose: require('./Logos/mose.png'),
  norbert: require('./Logos/norbert.png'),
  oshkosh: require('./Logos/oshkosh.png'),
  parkside: require('./Logos/parkside.png'),
  plateville: require('./Logos/plateville.png'),
  ripon: require('./Logos/ripon.png'),
  riverfalls: require('./Logos/riverfalls.jpg'),
  batman: require('./Logos/batman.jpg'),
  stout: require('./Logos/stout.png'),
  superior: require('./Logos/superior.png'),
  tribaleagles: require('./Logos/tribaleagles.jpg'),
  Umilkee: require('./Logos/Umilkee.png'),
  viterbo: require('./Logos/viterbo.png'),
  whitewater: require('./Logos/whitewater.jpg'),
  wiscoluth: require('./Logos/wiscoluth.jpg'),
  august: require('./Logos/august.png'),
  billinois: require('./Logos/billinois.jpg'),
  blackburn: require('./Logos/blackburn.png'),
  bradley: require('./Logos/bradley.png'),
  chicagostate: require('./Logos/chicagostate.png'),
  columbchic: require('./Logos/columbchic.png'),
  concochic: require('./Logos/concochic.png'),
  depaul: require('./Logos/depaul.png'),
  domichic: require('./Logos/domichic.jpg'),
  eastilli: require('./Logos/eastilli.png'),
  eastwest: require('./Logos/eastwest.jpg'),
  elmhurst: require('./Logos/elmhurst.png'),
  eurekachik: require('./Logos/eurekachik.png'),
  governors: require('./Logos/governors.jpg'),
  greenville: require('./Logos/greenville.png'),
  htc: require('./Logos/htc.jpg'),
  illicollege: require('./Logos/illicollege.jpg'),
  illistate: require('./Logos/illistate.png'),
  illitech: require('./Logos/illitech.jpg'),
  illiwesle: require('./Logos/illiwesle.png'),
  illurban: require('./Logos/illurban.jpg'),
  judson: require('./Logos/judson.png'),
  knox: require('./Logos/knox.jpg'),
  lakeforest: require('./Logos/lakeforest.png'),
  lewis: require('./Logos/lewis.jpg'),
  lincochrist: require('./Logos/lincochrist.jpg'),
  loyolachic: require('./Logos/loyolachic.jpg'),
  mckendree: require('./Logos/mckendree.jpg'),
  methill: require('./Logos/methill.png'),
  monmouth: require('./Logos/monmouth.png'),
  moody: require('./Logos/moody.jpg'),
  nationalouis: require('./Logos/nationalouis.jpg'),
  neilli: require('./Logos/neilli.jpg'),
  northcent: require('./Logos/northcent.jpg'),
  northilli: require('./Logos/northilli.png'),
  northpark: require('./Logos/northpark.jpg'),
  nwilli: require('./Logos/nwilli.jpg'),
  olivetilli: require('./Logos/olivetilli.png'),
  principia: require('./Logos/principia.jpg'),
  qiuincy: require('./Logos/qiuincy.jpg'),
  rockford: require('./Logos/rockford.png'),
  roosevelt: require('./Logos/roosevelt.jpg'),
  saic: require('./Logos/saic.png'),
  siue: require('./Logos/siue.png'),
  siuwolves: require('./Logos/siuwolves.jpg'),
  stanthony: require('./Logos/stanthony.jpg'),
  stfrancis: require('./Logos/stfrancis.png'),
  stxavier: require('./Logos/stxavier.png'),
  trinityill: require('./Logos/trinityill.png'),
  trinityIU: require('./Logos/trinityIU.png'),
  Uchicago: require('./Logos/Uchicago.png'),
  uicill: require('./Logos/uicill.png'),
  uispringfield: require('./Logos/uispringfield.png'),
  vandercook: require('./Logos/vandercook.jpg'),
  westilli: require('./Logos/westilli.png'),
  wheaton: require('./Logos/wheaton.jpg'),
  alice: require('./Logos/alice.png'),
  asbury: require('./Logos/asbury.png'),
  bellarmine: require('./Logos/bellarmine.png'),
  berea: require('./Logos/berea.jpg'),
  brescia: require('./Logos/brescia.png'),
  campbellsville: require('./Logos/campbellsville.png'),
  centrekfc: require('./Logos/centrekfc.jpg'),
  creek: require('./Logos/creek.png'),
  cumberlands: require('./Logos/cumberlands.png'),
  eastkfc: require('./Logos/eastkfc.jpg'),
  georgetown: require('./Logos/georgetown.png'),
  kfchrist: require('./Logos/kfchrist.png'),
  kfcstate: require('./Logos/kfcstate.png'),
  kfcwesle: require('./Logos/kfcwesle.jpg'),
  kmbc: require('./Logos/kmbc.png'),
  lindsey: require('./Logos/lindsey.png'),
  midway: require('./Logos/midway.png'),
  morekfc: require('./Logos/morekfc.png'),
  murray: require('./Logos/murray.jpg'),
  northkfc: require('./Logos/northkfc.png'),
  redbird: require('./Logos/redbird.png'),
  southsemi: require('./Logos/southsemi.png'),
  spalding: require('./Logos/spalding.jpg'),
  sullivan: require('./Logos/sullivan.png'),
  thomaskfc: require('./Logos/thomaskfc.jpg'),
  transkfc: require('./Logos/transkfc.png'),
  Ucommon: require('./Logos/Ucommon.jpg'),
  Ukfc: require('./Logos/Ukfc.png'),
  Upike: require('./Logos/Upike.png'),
  westkfc: require('./Logos/westkfc.png'),
  alcorn: require('./Logos/alcorn.png'),
  belhaven: require('./Logos/belhaven.png'),
  bluemo: require('./Logos/bluemo.jpg'),
  deltamis: require('./Logos/deltamis.jpg'),
  jackmis: require('./Logos/jackmis.png'),
  millsaps: require('./Logos/millsaps.png'),
  missicol: require('./Logos/missicol.png'),
  missistate: require('./Logos/missistate.png'),
  missivalley: require('./Logos/missivalley.png'),
  missiwomen: require('./Logos/missiwomen.png'),
  rust: require('./Logos/rust.png'),
  southmissi: require('./Logos/southmissi.jpg'),
  tougaloo: require('./Logos/tougaloo.png'),
  Umissi: require('./Logos/Umissi.png'),
  USmissi: require('./Logos/USmissi.jpg'),
  willcare: require('./Logos/willcare.jpg'),
  americabap: require('./Logos/americabap.png'),
  aquinas: require('./Logos/aquinas.png'),
  belmont: require('./Logos/belmont.png'),
  bethelu: require('./Logos/bethelu.png'),
  blueheal: require('./Logos/blueheal.png'),
  bryan: require('./Logos/bryan.png'),
  carson: require('./Logos/carson.jpg'),
  chatta: require('./Logos/chatta.png'),
  christbro: require('./Logos/christbro.png'),
  cumberland: require('./Logos/cumberland.png'),
  eastens: require('./Logos/eastens.png'),
  fisk: require('./Logos/fisk.jpg'),
  hardman: require('./Logos/hardman.png'),
  johnson: require('./Logos/johnson.jpg'),
  king: require('./Logos/king.jpg'),
  knoxville: require('./Logos/knoxville.png'),
  lane: require('./Logos/lane.png'),
  Lee: require('./Logos/Lee.png'),
  lipscomb: require('./Logos/lipscomb.png'),
  LMU: require('./Logos/LMU.png'),
  maryville: require('./Logos/maryville.png'),
  middleten: require('./Logos/middleten.png'),
  milligan: require('./Logos/milligan.png'),
  millikin: require('./Logos/millikin.png'),
  owen: require('./Logos/owen.png'),
  peay: require('./Logos/peay.png'),
  rhodes: require('./Logos/rhodes.jpg'),
  sewanee: require('./Logos/sewanee.jpg'),
  soadventist: require('./Logos/soadventist.png'),
  southcollege: require('./Logos/southcollege.png'),
  tenstate: require('./Logos/tenstate.png'),
  tentech: require('./Logos/tentech.png'),
  tenwesle: require('./Logos/tenwesle.png'),
  trevecca: require('./Logos/trevecca.jpg'),
  tusculum: require('./Logos/tusculum.png'),
  Umemphis: require('./Logos/Umemphis.png'),
  Union: require('./Logos/Union.png'),
  UTmartin: require('./Logos/UTmartin.png'),
  UTsouth: require('./Logos/UTsouth.png'),
  vanderbilt: require('./Logos/vanderbilt.jpg'),
  welch: require('./Logos/welch.png'),
  adrian: require('./Logos/adrian.jpg'),
  alabamaAM: require('./Logos/alabamaAM.png'),
  alabstate: require('./Logos/alabstate.png'),
  albion: require('./Logos/albion.png'),
  alma: require('./Logos/alma.png'),
  andrews: require('./Logos/andrews.jpg'),
  aqcollege: require('./Logos/aqcollege.jpg'),
  auburn: require('./Logos/auburn.png'),
  AUM: require('./Logos/AUM.png'),
  bakercol: require('./Logos/bakercol.png'),
  calvinmic: require('./Logos/calvinmic.png'),
  CCSmich: require('./Logos/CCSmich.png'),
  centmich: require('./Logos/centmich.png'),
  cleary: require('./Logos/cleary.png'),
  conU: require('./Logos/conU.png'),
  cornstone: require('./Logos/cornstone.png'),
  davenport: require('./Logos/davenport.png'),
  dearborn: require('./Logos/dearborn.png'),
  Detroit: require('./Logos/Detroit.png'),
  dtamps: require('./Logos/dtamps.png'),
  eastmich: require('./Logos/eastmich.png'),
  faulkner: require('./Logos/faulkner.png'),
  ferris: require('./Logos/ferris.jpg'),
  grace: require('./Logos/grace.jpg'),
  grandvall: require('./Logos/grandvall.png'),
  greatlake: require('./Logos/greatlake.png'),
  heritageab: require('./Logos/heritageab.png'),
  hillsdale: require('./Logos/hillsdale.png'),
  hopemich: require('./Logos/hopemich.png'),
  huntingdon: require('./Logos/huntingdon.png'),
  huntsville: require('./Logos/huntsville.png'),
  jaxstate: require('./Logos/jaxstate.png'),
  kalamazoo: require('./Logos/kalamazoo.png'),
  kettering: require('./Logos/kettering.png'),
  kuyper: require('./Logos/kuyper.png'),
  lakesup: require('./Logos/lakesup.png'),
  lawtech: require('./Logos/lawtech.jpg'),
  madonna: require('./Logos/madonna.jpg'),
  Mflint: require('./Logos/Mflint.png'),
  michstate: require('./Logos/michstate.jpg'),
  michtech: require('./Logos/michtech.jpg'),
  miles: require('./Logos/miles.png'),
  montevallo: require('./Logos/montevallo.png'),
  northalab: require('./Logos/northalab.png'),
  northmich: require('./Logos/northmich.jpg'),
  northwood: require('./Logos/northwood.png'),
  oakland: require('./Logos/oakland.jpg'),
  oakwood: require('./Logos/oakwood.png'),
  rochrist: require('./Logos/rochrist.jpg'),
  sacred: require('./Logos/sacred.png'),
  saginaw: require('./Logos/saginaw.jpg'),
  samford: require('./Logos/samford.jpg'),
  southalab: require('./Logos/southalab.png'),
  springa: require('./Logos/springa.jpg'),
  springhill: require('./Logos/springhill.png'),
  stillman: require('./Logos/stillman.jpg'),
  tornado: require('./Logos/tornado.jpg'),
  troy: require('./Logos/troy.png'),
  tuskegee: require('./Logos/tuskegee.png'),
  UAB: require('./Logos/UAB.png'),
  Ualab: require('./Logos/Ualab.png'),
  Umobile: require('./Logos/Umobile.png'),
  UOlivet: require('./Logos/UOlivet.png'),
  waynes: require('./Logos/waynes.png'),
  westalab: require('./Logos/westalab.png'),
  anderson: require('./Logos/anderson.png'),
  ball: require('./Logos/ball.png'),
  bethelind: require('./Logos/bethelind.png'),
  butler: require('./Logos/butler.png'),
  huntington: require('./Logos/huntington.png'),
  calumet: require('./Logos/calumet.jpg'),
  depauw: require('./Logos/depauw.jpg'),
  earlham: require('./Logos/earlham.jpg'),
  evansville: require('./Logos/evansville.png'),
  franklin: require('./Logos/franklin.jpg'),
  goshen: require('./Logos/goshen.png'),
  graceind: require('./Logos/graceind.png'),
  hanover: require('./Logos/hanover.png'),
  holycros: require('./Logos/holycros.jpg'),
  indfortnite: require('./Logos/indfortnite.png'),
  indiaeast: require('./Logos/indiaeast.jpg'),
  indiastate: require('./Logos/indiastate.png'),
  indiatech: require('./Logos/indiatech.png'),
  indiaU: require('./Logos/indiaU.png'),
  indicolumbus: require('./Logos/indicolumbus.png'),
  indiwesle: require('./Logos/indiwesle.png'),
  iupui: require('./Logos/iupui.jpg'),
  kokomo: require('./Logos/kokomo.png'),
  manchester: require('./Logos/manchester.png'),
  maindia: require('./Logos/maindia.jpg'),
  martinU: require('./Logos/martinU.png'),
  maryind: require('./Logos/maryind.png'),
  notredame: require('./Logos/notredame.png'),
  oakcity: require('./Logos/oakcity.jpg'),
  purduefor: require('./Logos/purduefor.png'),
  purduenw: require('./Logos/purduenw.jpg'),
  purduew: require('./Logos/purduew.png'),
  rosehulman: require('./Logos/rosehulman.png'),
  SMWc: require('./Logos/SMWc.png'),
  southbend: require('./Logos/southbend.png'),
  southindi: require('./Logos/southindi.png'),
  taylor: require('./Logos/taylor.jpg'),
  trine: require('./Logos/trine.jpg'),
  Ufrancis: require('./Logos/Ufrancis.png'),
  Uindipolis: require('./Logos/Uindipolis.png'),
  Usoindia: require('./Logos/Usoindia.png'),
  valparaiso: require('./Logos/valparaiso.png'),
  wabash: require('./Logos/wabash.png'),
  westindia: require('./Logos/westindia.png'),
  akron: require('./Logos/akron.png'),
  antioch: require('./Logos/antioch.jpg'),
  artohio: require('./Logos/artohio.png'),
  ashland: require('./Logos/ashland.jpg'),
  baldwin: require('./Logos/baldwin.png'),
  bluffton: require('./Logos/bluffton.jpg'),
  bowling: require('./Logos/bowling.png'),
  capital: require('./Logos/capital.jpg'),
  casewest: require('./Logos/casewest.png'),
  cedarville: require('./Logos/cedarville.jpg'),
  centstate: require('./Logos/centstate.png'),
  cleveart: require('./Logos/cleveart.jpg'),
  clevemusic: require('./Logos/clevemusic.png'),
  clevestate: require('./Logos/clevestate.jpg'),
  colart: require('./Logos/colart.png'),
  defianceoh: require('./Logos/defianceoh.jpg'),
  denison: require('./Logos/denison.png'),
  erie: require('./Logos/erie.jpg'),
  findlay: require('./Logos/findlay.png'),
  franklinoh: require('./Logos/franklinoh.png'),
  Godbib: require('./Logos/Godbib.jpg'),
  heidel: require('./Logos/heidel.jpg'),
  hiram: require('./Logos/hiram.jpg'),
  johnoh: require('./Logos/johnoh.png'),
  kentst: require('./Logos/kentst.png'),
  kenyon: require('./Logos/kenyon.png'),
  kettohio: require('./Logos/kettohio.png'),
  lakecampus: require('./Logos/lakecampus.png'),
  lourdes: require('./Logos/lourdes.jpg'),
  malone: require('./Logos/malone.png'),
  marietta: require('./Logos/marietta.png'),
  mercyoh: require('./Logos/mercyoh.png'),
  miamioh: require('./Logos/miamioh.png'),
  mtcarmel: require('./Logos/mtcarmel.png'),
  mtjose: require('./Logos/mtjose.jpg'),
  mtunion: require('./Logos/mtunion.jpg'),
  muskingum: require('./Logos/muskingum.jpg'),
  oberlin: require('./Logos/oberlin.jpg'),
  ohiochrist: require('./Logos/ohiochrist.png'),
  ohiodomi: require('./Logos/ohiodomi.png'),
  ohionorth: require('./Logos/ohionorth.png'),
  ohiostate: require('./Logos/ohiostate.png'),
  ohioU: require('./Logos/ohioU.png'),
  ohiowesle: require('./Logos/ohiowesle.png'),
  otterbein: require('./Logos/otterbein.jpg'),
  pontifical: require('./Logos/pontifical.jpg'),
  shawnee: require('./Logos/shawnee.png'),
  steub: require('./Logos/steub.png'),
  tiffin: require('./Logos/tiffin.png'),
  toledo: require('./Logos/toledo.jpg'),
  udayton: require('./Logos/udayton.png'),
  UNOH: require('./Logos/UNOH.png'),
  uriogrande: require('./Logos/uriogrande.png'),
  ursuline: require('./Logos/ursuline.png'),
  vernon: require('./Logos/vernon.png'),
  walshoh: require('./Logos/walshoh.jpg'),
  wilberforce: require('./Logos/wilberforce.jpg'),
  wilmington: require('./Logos/wilmington.png'),
  wittenberg: require('./Logos/wittenberg.png'),
  wooster: require('./Logos/wooster.jpg'),
  wright: require('./Logos/wright.jpg'),
  xavieroh: require('./Logos/xavieroh.png'),
  youngstown: require('./Logos/youngstown.png'),
  alabible: require('./Logos/alabible.png'),
  alapacific: require('./Logos/alapacific.png'),
  anchorage: require('./Logos/anchorage.jpg'),
  byuhaw: require('./Logos/byuhaw.png'),
  chaminade: require('./Logos/chaminade.png'),
  fairbanks: require('./Logos/fairbanks.png'),
  hawpacific: require('./Logos/hawpacific.png'),
  southalaska: require('./Logos/southalaska.png'),
  Uhawa: require('./Logos/Uhawa.jpg'),
  Uhilo: require('./Logos/Uhilo.png'),
  Umanoa: require('./Logos/Umanoa.png'),
  westhaw: require('./Logos/westhaw.png'),
  ACPHS: require('./Logos/ACPHS.png'),
  adelphi: require('./Logos/adelphi.png'),
  alfredstate: require('./Logos/alfredstate.png'),
  bard: require('./Logos/bard.png'),
  barnard: require('./Logos/barnard.png'),
  bates: require('./Logos/bates.png'),
  bennington: require('./Logos/bennington.jpg'),
  bowdoin: require('./Logos/bowdoin.png'),
  champlain: require('./Logos/champlain.png'),
  colatlantic: require('./Logos/colatlantic.png'),
  colby: require('./Logos/colby.png'),
  dartmouth: require('./Logos/dartmouth.png'),
  farmington: require('./Logos/farmington.jpg'),
  fortkent: require('./Logos/fortkent.png'),
  fpierce: require('./Logos/fpierce.jpg'),
  hampman: require('./Logos/hampman.jpg'),
  husson: require('./Logos/husson.png'),
  keene: require('./Logos/keene.png'),
  landmark: require('./Logos/landmark.png'),
  machias: require('./Logos/machias.jpg'),
  mainaug: require('./Logos/mainaug.png'),
  Maine: require('./Logos/Maine.png'),
  ship: require('./Logos/ship.jpg'),
  meca: require('./Logos/meca.png'),
  middlebury: require('./Logos/middlebury.png'),
  newengland: require('./Logos/newengland.jpg'),
  newhamp: require('./Logos/newhamp.png'),
  norwich: require('./Logos/norwich.png'),
  nweng: require('./Logos/nweng.png'),
  plymouth: require('./Logos/plymouth.png'),
  presque: require('./Logos/presque.jpg'),
  rivier: require('./Logos/rivier.png'),
  sawyer: require('./Logos/sawyer.jpg'),
  SNHU: require('./Logos/SNHU.png'),
  somaine: require('./Logos/somaine.png'),
  stanselm: require('./Logos/stanselm.png'),
  sterlingc: require('./Logos/sterling.png'),
  stmaine: require('./Logos/stmaine.png'),
  stmichael: require('./Logos/stmichael.png'),
  thomasM: require('./Logos/thomasM.png'),
  thomore: require('./Logos/thomore.png'),
  Unitye: require('./Logos/Unitye.png'),
  Uvermont: require('./Logos/Uvermont.png'),
  vermontst: require('./Logos/vermontst.png'),
  fivetowns: require('./Logos/fivetowns.png'),
  baruch: require('./Logos/baruch.png'),
  berkny: require('./Logos/berkny.jpg'),
  binghamton: require('./Logos/binghamton.png'),
  boricua: require('./Logos/boricua.jpg'),
  brockport: require('./Logos/brockport.png'),
  brooklynco: require('./Logos/brooklynco.png'),
  buffalost: require('./Logos/buffalost.png'),
  canisius: require('./Logos/canisius.png'),
  canton: require('./Logos/canton.png'),
  citytech: require('./Logos/citytech.png'),
  clarksonNY: require('./Logos/clarksonNY.png'),
  cobleskill: require('./Logos/cobleskill.png'),
  colgate: require('./Logos/colgate.png'),
  collegeNY: require('./Logos/collegeNY.png'),
  cooper: require('./Logos/cooper.png'),
  cornell: require('./Logos/cornell.png'),
  cortland: require('./Logos/cortland.png'),
  CSIny: require('./Logos/CSIny.jpg'),
  culinary: require('./Logos/culinary.png'),
  daemen: require('./Logos/daemen.png'),
  davis: require('./Logos/davis.png'),
  delhiny: require('./Logos/delhiny.png'),
  domiNY: require('./Logos/domiNY.png'),
  DYU: require('./Logos/DYU.png'),
  elmira: require('./Logos/elmira.jpg'),
  empire: require('./Logos/empire.png'),
  ESF: require('./Logos/ESF.png'),
  eugene: require('./Logos/eugene.png'),
  farmingdale: require('./Logos/farmingdale.png'),
  FIT: require('./Logos/FIT.jpg'),
  fordham: require('./Logos/fordham.png'),
  fredonia: require('./Logos/fredonia.png'),
  geneseo: require('./Logos/geneseo.png'),
  hamilton: require('./Logos/hamilton.png'),
  hartwick: require('./Logos/hartwick.png'),
  hilbert: require('./Logos/hilbert.png'),
  hobart: require('./Logos/hobart.jpg'),
  hofstra: require('./Logos/hofstra.png'),
  houghton: require('./Logos/houghton.jpg'),
  hunter: require('./Logos/hunter.jpg'),
  iona: require('./Logos/iona.jpg'),
  ithaca: require('./Logos/ithaca.png'),
  johnfish: require('./Logos/johnfish.jpg'),
  johnjay: require('./Logos/johnjay.png'),
  johnNY: require('./Logos/johnNY.png'),
  josephny: require('./Logos/josephny.png'),
  JTS: require('./Logos/JTS.png'),
  julliard: require('./Logos/julliard.jpg'),
  keuka: require('./Logos/keuka.jpg'),
  lehman: require('./Logos/lehman.jpg'),
  lemoyne: require('./Logos/lemoyne.png'),
  LIM: require('./Logos/LIM.png'),
  LIUbrook: require('./Logos/LIUbrook.png'),
  LIUpost: require('./Logos/LIUpost.png'),
  manhatmuisc: require('./Logos/manhatmuisc.jpg'),
  manhatU: require('./Logos/manhatU.png'),
  manhatville: require('./Logos/manhatville.png'),
  marist: require('./Logos/marist.png'),
  maritime: require('./Logos/maritime.png'),
  marymanhat: require('./Logos/marymanhat.png'),
  medgar: require('./Logos/medgar.jpg'),
  mercyny: require('./Logos/mercyny.png'),
  metrony: require('./Logos/metrony.jpg'),
  molloy: require('./Logos/molloy.png'),
  monroE: require('./Logos/monroE.png'),
  morrisville: require('./Logos/morrisville.png'),
  nazareth: require('./Logos/nazareth.png'),
  newpaltz: require('./Logos/newpaltz.png'),
  newpublic: require('./Logos/newpublic.jpg'),
  newschool: require('./Logos/newschool.png'),
  niagara: require('./Logos/niagara.png'),
  NYinterior: require('./Logos/NYinterior.png'),
  NYtech: require('./Logos/NYtech.jpg'),
  oneonta: require('./Logos/oneonta.png'),
  oswego: require('./Logos/oswego.png'),
  PACE: require('./Logos/PACE.png'),
  parsons: require('./Logos/parsons.png'),
  plattsburgh: require('./Logos/plattsburgh.jpg'),
  potsdam: require('./Logos/potsdam.jpg'),
  Pratt: require('./Logos/Pratt.jpg'),
  psmithcol: require('./Logos/psmithcol.jpg'),
  purchase: require('./Logos/purchase.png'),
  queens: require('./Logos/queens.png'),
  renesalar: require('./Logos/renesalar.png'),
  RIT: require('./Logos/RIT.png'),
  robertny: require('./Logos/robertny.png'),
  rochester: require('./Logos/rochester.png'),
  russelsage: require('./Logos/russelsage.png'),
  sarah: require('./Logos/sarah.png'),
  siena: require('./Logos/siena.png'),
  skidmore: require('./Logos/skidmore.png'),
  stbona: require('./Logos/stbona.jpg'),
  stfrancisny: require('./Logos/stfrancisny.jpg'),
  stlawrence: require('./Logos/stlawrence.png'),
  stneyork: require('./Logos/stneyork.png'),
  stonybrook: require('./Logos/stonybrook.jpg'),
  sunolo: require('./Logos/sunolo.jpg'),
  montvincent: require('./Logos/montvincent.png'),
  sunypoly: require('./Logos/sunypoly.jpg'),
  SVAnyc: require('./Logos/SVAnyc.jpg'),
  syracuse: require('./Logos/syracuse.png'),
  thomaq: require('./Logos/thomaq.jpg'),
  tourony: require('./Logos/tourony.jpg'),
  Ualbany: require('./Logos/Ualbany.png'),
  Ubuffalo: require('./Logos/Ubuffalo.png'),
  uniO: require('./Logos/uniO.png'),
  utica: require('./Logos/utica.jpg'),
  vassar: require('./Logos/vassar.png'),
  vaughn: require('./Logos/vaughn.png'),
  wagner: require('./Logos/wagner.jpg'),
  webb: require('./Logos/webb.png'),
  westbury: require('./Logos/westbury.jpg'),
  yeshiva: require('./Logos/yeshiva.png'),
  york: require('./Logos/york.jpg'),
  albertus: require('./Logos/albertus.jpg'),
  bridgeport: require('./Logos/bridgeport.png'),
  brown: require('./Logos/brown.png'),
  bryant: require('./Logos/bryant.png'),
  centralconn: require('./Logos/centralconn.png'),
  connecoll: require('./Logos/connecoll.png'),
  dellstate: require('./Logos/dellstate.png'),
  eastconne: require('./Logos/eastconne.png'),
  engtech: require('./Logos/engtech.png'),
  fairfield: require('./Logos/fairfield.png'),
  goldey: require('./Logos/goldey.png'),
  greeendell: require('./Logos/greeendell.png'),
  hartford: require('./Logos/hartford.jpg'),
  holyapo: require('./Logos/holyapo.jpg'),
  jwale: require('./Logos/jwale.png'),
  mitchell: require('./Logos/mitchell.png'),
  newhaven: require('./Logos/newhaven.png'),
  paier: require('./Logos/paier.png'),
  postu: require('./Logos/postu.png'),
  priars: require('./Logos/priars.png'),
  quinni: require('./Logos/quinni.png'),
  rhode: require('./Logos/rhode.png'),
  RISD: require('./Logos/RISD.png'),
  roger: require('./Logos/roger.jpg'),
  salve: require('./Logos/salve.jpg'),
  sacredhe: require('./Logos/sacredhe.png'),
  southconne: require('./Logos/southconne.png'),
  stconne: require('./Logos/stconne.png'),
  trinityconn: require('./Logos/trinityconn.png'),
  Uconne: require('./Logos/Uconne.png'),
  Udela: require('./Logos/Udela.png'),
  Urhodei: require('./Logos/Urhodei.png'),
  wesleyan: require('./Logos/wesleyan.png'),
  Yale: require('./Logos/Yale.png'),
  AIC: require('./Logos/AIC.png'),
  amherst: require('./Logos/amherst.png'),
  annamaria: require('./Logos/annamaria.png'),
  assumption: require('./Logos/assumption.jpg'),
  babson: require('./Logos/babson.png'),
  baypath: require('./Logos/baypath.png'),
  bentley: require('./Logos/bentley.png'),
  berklee: require('./Logos/berklee.jpg'),
  bostonach: require('./Logos/bostonach.png'),
  bostonbap: require('./Logos/bostonbap.png'),
  bostoncol: require('./Logos/bostoncol.png'),
  bostonconserve: require('./Logos/bostonconserve.png'),
  bostonholy: require('./Logos/bostonholy.jpg'),
  bostonuni: require('./Logos/bostonuni.png'),
  brandeis: require('./Logos/brandeis.jpg'),
  bridgewater: require('./Logos/bridgewater.png'),
  cambridgecol: require('./Logos/cambridgecol.png'),
  clarkuni: require('./Logos/clarkuni.png'),
  currycol: require('./Logos/currycol.png'),
  deancol: require('./Logos/deancol.jpg'),
  eastnaz: require('./Logos/eastnaz.jpg'),
  elmscol: require('./Logos/elmscol.png'),
  emerson: require('./Logos/emerson.png'),
  emmanuel: require('./Logos/emmanuel.png'),
  endicott: require('./Logos/endicott.png'),
  fisher: require('./Logos/fisher.png'),
  fitchburg: require('./Logos/fitchburg.png'),
  framingham: require('./Logos/framingham.jpg'),
  gordonmas: require('./Logos/gordonmas.png'),
  hampshire: require('./Logos/hampshire.png'),
  hellenic: require('./Logos/hellenic.jpg'),
  holyoke: require('./Logos/holyoke.png'),
  lasell: require('./Logos/lasell.jpg'),
  lesley: require('./Logos/lesley.jpg'),
  longy: require('./Logos/longy.png'),
  massart: require('./Logos/massart.png'),
  massmari: require('./Logos/massmari.png'),
  MCLA: require('./Logos/MCLA.jpg'),
  MCPHS: require('./Logos/MCPHS.png'),
  merrimack: require('./Logos/merrimack.png'),
  MIT: require('./Logos/MIT.jpg'),
  montserrat: require('./Logos/montserrat.jpg'),
  NEC: require('./Logos/NEC.png'),
  nichols: require('./Logos/nichols.png'),
  northboston: require('./Logos/northboston.png'),
  northpoint: require('./Logos/northpoint.png'),
  olincol: require('./Logos/olincol.jpg'),
  yellow: require('./Logos/yellow.jpg'),
  salem: require('./Logos/salem.png'),
  simmons: require('./Logos/simmons.png'),
  simonrock: require('./Logos/simonrock.png'),
  SMFA: require('./Logos/SMFA.png'),
  smithcol: require('./Logos/smithcol.png'),
  springbos: require('./Logos/springbos.jpg'),
  stonehill: require('./Logos/stonehill.jpg'),
  suffolk: require('./Logos/suffolk.png'),
  tufts: require('./Logos/tufts.png'),
  umassam: require('./Logos/umassam.jpg'),
  umassbos: require('./Logos/umassbos.jpg'),
  umassdart: require('./Logos/umassdart.png'),
  umasslow: require('./Logos/umasslow.png'),
  wboston: require('./Logos/wboston.jpg'),
  wellesley: require('./Logos/wellesley.png'),
  wentworth: require('./Logos/wentworth.jpg'),
  westfield: require('./Logos/westfield.png'),
  willi: require('./Logos/willi.png'),
  WNE: require('./Logos/WNE.png'),
  wokestate: require('./Logos/wokestate.jpg'),
  WPI: require('./Logos/WPI.png'), 
  berkjersey: require('./Logos/berkjersey.jpg'), 
  bloomfield: require('./Logos/bloomfield.png'), 
  brunswick: require('./Logos/brunswick.jpg'), 
  caldwell: require('./Logos/caldwell.png'), 
  cent: require('./Logos/cent.jpg'), 
  court: require('./Logos/court.jpg'), 
  drew: require('./Logos/drew.png'), 
  eastinter: require('./Logos/eastinter.png'), 
  FDU: require('./Logos/FDU.png'), 
  felician: require('./Logos/felician.jpg'), 
  keanu: require('./Logos/keanu.jpg'), 
  monblue: require('./Logos/monblue.jpg'), 
  montclair: require('./Logos/montclair.jpg'), 
  njcu: require('./Logos/njcu.jpg'), 
  NJIT: require('./Logos/NJIT.png'), 
  princeton: require('./Logos/princeton.png'), 
  ramapo: require('./Logos/ramapo.png'), 
  rider: require('./Logos/rider.jpg'), 
  rnewark: require('./Logos/rnewark.png'), 
  rowanU: require('./Logos/rowanU.png'), 
  rutgers: require('./Logos/rutgers.png'), 
  setonhall: require('./Logos/setonhall.png'), 
  steliza: require('./Logos/steliza.png'), 
  stevens: require('./Logos/stevens.png'), 
  stockton: require('./Logos/stockton.png'), 
  stpeter: require('./Logos/stpeter.jpg'), 
  TCNJ: require('./Logos/TCNJ.jpg'), 
  TESU: require('./Logos/TESU.png'), 
  abington: require('./Logos/abington.jpg'),
  albright: require('./Logos/albright.png'),
  allegheny: require('./Logos/allegheny.jpg'),
  alvernia: require('./Logos/alvernia.png'),
  arcadia: require('./Logos/arcadia.png'),
  bradford: require('./Logos/bradford.jpg'),
  brynn: require('./Logos/brynn.png'),
  bucknell: require('./Logos/bucknell.png'),
  cairn: require('./Logos/cairn.png'),
  carlow: require('./Logos/carlow.png'),
  carnegie: require('./Logos/carnegie.png'),
  cedarcrest: require('./Logos/cedarcrest.png'),
  centpenn: require('./Logos/centpenn.png'),
  chatham: require('./Logos/chatham.png'),
  chestnut: require('./Logos/chestnut.jpg'),
  curtis: require('./Logos/curtis.jpg'),
  delavall: require('./Logos/delavall.png'),
  desales: require('./Logos/desales.png'),
  dickinson: require('./Logos/dickinson.png'),
  drexel: require('./Logos/drexel.png'),
  duquesne: require('./Logos/duquesne.jpg'),
  eaststroud: require('./Logos/eaststroud.png'),
  eastuni: require('./Logos/eastuni.png'),
  elizacol: require('./Logos/elizacol.png'),
  FM: require('./Logos/FM.png'),
  geneva: require('./Logos/geneva.png'),
  gettysburg: require('./Logos/gettysburg.png'),
  greensburg: require('./Logos/greensburg.jpg'),
  grovec: require('./Logos/grovec.png'),
  GU: require('./Logos/GU.png'),
  harrisburg: require('./Logos/harrisburg.jpg'),
  haverford: require('./Logos/haverford.png'),
  holyfam: require('./Logos/holyfam.jpg'),
  immaculata: require('./Logos/immaculata.png'),
  indipenn: require('./Logos/indipenn.png'),
  johnstown: require('./Logos/johnstown.png'),
  juniata: require('./Logos/juniata.png'),
  KC: require('./Logos/KC.jpg'),
  kingscol: require('./Logos/kingscol.png'),
  kutztown: require('./Logos/kutztown.png'),
  lackawa: require('./Logos/lackawa.jpg'),
  lancaster: require('./Logos/lancaster.jpg'),
  laroche: require('./Logos/laroche.png'),
  lasalle: require('./Logos/lasalle.png'),
  lehigh: require('./Logos/lehigh.png'),
  lincolnU: require('./Logos/lincolnU.png'),
  LVC: require('./Logos/LVC.jpg'),
  lycoming: require('./Logos/lycoming.png'),
  manor: require('./Logos/manor.png'),
  marywood: require('./Logos/marywood.jpg'),
  mawr: require('./Logos/mawr.jpg'),
  mercyhurst: require('./Logos/mercyhurst.png'),
  messiah: require('./Logos/messiah.png'),
  millersville: require('./Logos/millersville.png'),
  misericordia: require('./Logos/misericordia.png'),
  mOOre: require('./Logos/mOOre.png'),
  colusc: require('./Logos/colusc.png'),
  moravian: require('./Logos/moravian.jpg'),
  mounties: require('./Logos/mounties.jpg'),
  muhlenberg: require('./Logos/muhlenberg.png'),
  neumann: require('./Logos/neumann.png'),
  nuthill: require('./Logos/nuthill.png'),
  peirce: require('./Logos/peirce.png'),
  pentech: require('./Logos/pentech.png'),
  pointpark: require('./Logos/pointpark.jpg'),
  RMU: require('./Logos/RMU.png'),
  rosemont: require('./Logos/rosemont.png'),
  scranton: require('./Logos/scranton.png'),
  seton: require('./Logos/seton.png'),
  sfU: require('./Logos/sfU.png'),
  shippens: require('./Logos/shippens.png'),
  sjU: require('./Logos/sjU.jpg'),
  slippery: require('./Logos/slippery.png'),
  stvincent: require('./Logos/stvincent.jpg'),
  susque: require('./Logos/susque.jpg'),
  swarthmore: require('./Logos/swarthmore.jpg'),
  Temple: require('./Logos/Temple.png'),
  thiel: require('./Logos/thiel.jpg'),
  thojeff: require('./Logos/thojeff.png'),
  Upenn: require('./Logos/Upenn.png'),
  Upitts: require('./Logos/Upitts.png'),
  ursinus: require('./Logos/ursinus.png'),
  valleyforge: require('./Logos/valleyforge.jpg'),
  villanova: require('./Logos/villanova.png'),
  washjeff: require('./Logos/washjeff.png'),
  waynesburg: require('./Logos/waynesburg.jpg'),
  westchest: require('./Logos/westchest.jpg'),
  westmini: require('./Logos/westmini.png'),
  widener: require('./Logos/widener.jpg'),
  wilkes: require('./Logos/wilkes.png'),
  wilsonco: require('./Logos/wilsonco.png'),
  yette: require('./Logos/yette.jpg'),
  yorkpen: require('./Logos/yorkpen.png'),
  bowiest: require('./Logos/bowiest.png'),
  capitoltech: require('./Logos/capitoltech.png'),
  coppin: require('./Logos/coppin.jpg'),
  eastshore: require('./Logos/eastshore.jpg'),
  frostburg: require('./Logos/frostburg.png'),
  goucher: require('./Logos/goucher.png'),
  hood: require('./Logos/hood.png'),
  hopkins: require('./Logos/hopkins.png'),
  loymary: require('./Logos/loymary.jpg'),
  mcdaniel: require('./Logos/mcdaniel.png'),
  MICA: require('./Logos/MICA.png'),
  morgst: require('./Logos/morgst.jpg'),
  mtma: require('./Logos/mtma.png'),
  nerisra: require('./Logos/nerisra.jpg'),
  notremary: require('./Logos/notremary.jpg'),
  salisma: require('./Logos/salisma.jpg'),
  sanjohn: require('./Logos/sanjohn.png'),
  sanmary: require('./Logos/sanmary.png'),
  stevee: require('./Logos/stevee.jpg'),
  towsonu: require('./Logos/towsonu.png'),
  umbc: require('./Logos/umbc.png'),
  umgc: require('./Logos/umgc.png'),
  washadventist: require('./Logos/washadventist.png'),
  washicoll: require('./Logos/washicoll.png'),
  americanU: require('./Logos/americanU.png'),
  americapublic: require('./Logos/americapublic.jpg'),
  applach: require('./Logos/applach.png'),
  bettany: require('./Logos/bettany.png'),
  bluefield: require('./Logos/bluefield.jpg'),
  catholic: require('./Logos/catholic.png'),
  charleston: require('./Logos/charleston.jpg'),
  daviselk: require('./Logos/daviselk.jpg'),
  district: require('./Logos/district.png'),
  fairmont: require('./Logos/fairmont.jpg'),
  gallaudet: require('./Logos/gallaudet.jpg'),
  gelnville: require('./Logos/gelnville.png'),
  geotown: require('./Logos/geotown.png'),
  GW: require('./Logos/GW.png'),
  Howard: require('./Logos/Howard.png'),
  lonlord: require('./Logos/lonlord.jpg'),
  parkersburg: require('./Logos/parkersburg.png'),
  potomac: require('./Logos/potomac.jpg'),
  bumu: require('./Logos/bumu.jpg'),
  shepherd: require('./Logos/shepherd.png'),
  theherd: require('./Logos/theherd.png'),
  Trin: require('./Logos/Trin.png'),
  virgtech: require('./Logos/virgtech.jpg'),
  virgwes: require('./Logos/virgwes.jpg'),
  westlib: require('./Logos/westlib.png'),
  westvirg: require('./Logos/westvirg.png'),
  wheeling: require('./Logos/wheeling.jpg'),
  wivig: require('./Logos/wivig.jpg'),
  averett: require('./Logos/averett.png'),
  beach: require('./Logos/beach.png'),
  bluefie: require('./Logos/bluefie.png'),
  bridgewate: require('./Logos/bridgewate.png'),
  christendom: require('./Logos/christendom.jpg'),
  CNU: require('./Logos/CNU.jpg'),
  ferrum: require('./Logos/ferrum.jpg'),
  georgema: require('./Logos/georgema.png'),
  hamptoN: require('./Logos/hamptoN.jpg'),
  henry: require('./Logos/henry.jpg'),
  hollins: require('./Logos/hollins.png'),
  jamesmad: require('./Logos/jamesmad.png'),
  liberty: require('./Logos/liberty.jpg'),
  longwood: require('./Logos/longwood.jpg'),
  lunchbar: require('./Logos/lunchbar.png'),
  mabaldy: require('./Logos/mabaldy.png'),
  mawash: require('./Logos/mawash.png'),
  mennonite: require('./Logos/mennonite.png'),
  mVu: require('./Logos/mVu.png'),
  norfolk: require('./Logos/norfolk.png'),
  oldomi: require('./Logos/oldomi.jpg'),
  pathenry: require('./Logos/pathenry.jpg'),
  radford: require('./Logos/radford.png'),
  randolph: require('./Logos/randolph.png'),
  reGent: require('./Logos/reGent.jpg'),
  richmo: require('./Logos/richmo.png'),
  rMc: require('./Logos/rMc.jpg'),
  roanoke: require('./Logos/roanoke.png'),
  shenando: require('./Logos/shenando.png'),
  sovirgi: require('./Logos/sovirgi.png'),
  sweety: require('./Logos/sweety.png'),
  sydney: require('./Logos/sydney.png'),
  Urichi: require('./Logos/Urichi.png'),
  uvawise: require('./Logos/uvawise.jpg'),
  Uvirgin: require('./Logos/Uvirgin.png'),
  VCU: require('./Logos/VCU.jpg'),
  virgilu: require('./Logos/virgilu.png'),
  virgistate: require('./Logos/virgistate.png'),
  virgitech: require('./Logos/virgitech.png'),
  virgwesle: require('./Logos/virgwesle.png'),
  VMI: require('./Logos/VMI.png'),
  wilmary: require('./Logos/wilmary.jpg'),
  wleeu: require('./Logos/wleeu.png'),
  abbey: require('./Logos/abbey.png'),
  ampbell: require('./Logos/ampbell.png'),
  appal: require('./Logos/appal.png'),
  asheville: require('./Logos/asheville.jpg'),
  barton: require('./Logos/barton.png'),
  brevard: require('./Logos/brevard.png'),
  cabarrus: require('./Logos/cabarrus.jpg'),
  carolart: require('./Logos/carolart.png'),
  carolina: require('./Logos/carolina.png'),
  carwesle: require('./Logos/carwesle.png'),
  catawba: require('./Logos/catawba.png'),
  chapelhil: require('./Logos/chapelhil.png'),
  charlO: require('./Logos/charlO.png'),
  chowan: require('./Logos/chowan.jpg'),
  churchca: require('./Logos/churchca.jpg'),
  davidson: require('./Logos/davidson.png'),
  duke: require('./Logos/duke.png'),
  ecsU: require('./Logos/ecsU.png'),
  ecU: require('./Logos/ecU.jpg'),
  elon: require('./Logos/elon.png'),
  fayst: require('./Logos/fayst.png'),
  gardner: require('./Logos/gardner.png'),
  greensboro: require('./Logos/greensboro.png'),
  guilford: require('./Logos/guilford.jpg'),
  highpoint: require('./Logos/highpoint.jpg'),
  ivstone: require('./Logos/ivstone.png'),
  jocsmith: require('./Logos/jocsmith.png'),
  jowale: require('./Logos/jowale.png'),
  leesmcra: require('./Logos/leesmcra.png'),
  lenoir: require('./Logos/lenoir.png'),
  marshill: require('./Logos/marshill.png'),
  meredith: require('./Logos/meredith.jpg'),
  midatla: require('./Logos/midatla.png'),
  montreat: require('./Logos/montreat.png'),
  nccent: require('./Logos/nccent.png'),
  nCs: require('./Logos/nCs.png'),
  ncta: require('./Logos/ncta.png'),
  nnett: require('./Logos/nnett.png'),
  odist: require('./Logos/odist.png'),
  olives: require('./Logos/olives.png'),
  pembroke: require('./Logos/pembroke.png'),
  pfeiff: require('./Logos/pfeiff.jpg'),
  queeen: require('./Logos/queeen.png'),
  salemCO: require('./Logos/salemCO.jpg'),
  sAu: require('./Logos/sAu.png'),
  shaW: require('./Logos/shaW.png'),
  uncgreen: require('./Logos/uncgreen.png'),
  wakefor: require('./Logos/wakefor.jpg'),
  warreN: require('./Logos/warreN.jpg'),
  westlina: require('./Logos/westlina.jpg'),
  wilming: require('./Logos/wilming.png'),
  wingate: require('./Logos/wingate.jpg'),
  wipeace: require('./Logos/wipeace.png'),
  WSSU: require('./Logos/WSSU.png'),
  aiken: require('./Logos/aiken.jpg'),
  allenU: require('./Logos/allenU.jpg'),
  andU: require('./Logos/andU.png'),
  blackdi: require('./Logos/blackdi.jpg'),
  bobojones: require('./Logos/bobojones.png'),
  buccan: require('./Logos/buccan.png'),
  charlie: require('./Logos/charlie.png'),
  claflin: require('./Logos/claflin.png'),
  clemsOn: require('./Logos/clemsOn.jpg'),
  coasco: require('./Logos/coasco.png'),
  coker: require('./Logos/coker.png'),
  colinter: require('./Logos/colinter.jpg'),
  converse: require('./Logos/converse.png'),
  dragon: require('./Logos/dragon.png'),
  erskine: require('./Logos/erskine.jpg'),
  furman: require('./Logos/furman.png'),
  lander: require('./Logos/lander.jpg'),
  marionF: require('./Logos/marionF.png'),
  motrian: require('./Logos/motrian.jpg'),
  newberry: require('./Logos/newberry.png'),
  northgreen: require('./Logos/northgreen.jpg'),
  presby: require('./Logos/presby.png'),
  pucol: require('./Logos/pucol.png'),
  scsta: require('./Logos/scsta.png'),
  sharks: require('./Logos/sharks.jpg'),
  souuni: require('./Logos/souuni.png'),
  thecit: require('./Logos/thecit.png'),
  upstate: require('./Logos/upstate.png'),
  vohees: require('./Logos/vohees.jpg'),
  winthrop: require('./Logos/winthrop.png'),
  wofford: require('./Logos/wofford.jpg'),
  abac: require('./Logos/abac.jpg'),
  agnesco: require('./Logos/agnesco.jpg'),
  albanysta: require('./Logos/albanysta.jpg'),
  atclark: require('./Logos/atclark.png'),
  atmetro: require('./Logos/atmetro.jpg'),
  augu: require('./Logos/augu.png'),
  berry: require('./Logos/berry.png'),
  bigG: require('./Logos/bigG.png'),
  brenau: require('./Logos/brenau.png'),
  brewtonp: require('./Logos/brewtonp.png'),
  calyst: require('./Logos/calyst.png'),
  coasgeo: require('./Logos/coasgeo.png'),
  colust: require('./Logos/colust.png'),
  covege: require('./Logos/covege.png'),
  daltonst: require('./Logos/daltonst.png'),
  emman: require('./Logos/emman.png'),
  emoryU: require('./Logos/emoryU.jpg'),
  fortga: require('./Logos/fortga.jpg'),
  gacolst: require('./Logos/gacolst.jpg'),
  gahigh: require('./Logos/gahigh.png'),
  gastateu: require('./Logos/gastateu.jpg'),
  gawesle: require('./Logos/gawesle.jpg'),
  geosout: require('./Logos/geosout.jpg'),
  geoSW: require('./Logos/geoSW.png'),
  geotech: require('./Logos/geotech.png'),
  gwinnett: require('./Logos/gwinnett.jpg'),
  hawks: require('./Logos/hawks.png'),
  interconA: require('./Logos/interconA.png'),
  kennesaw: require('./Logos/kennesaw.png'),
  lagrange: require('./Logos/lagrange.jpg'),
  life: require('./Logos/life.jpg'),
  lutherice: require('./Logos/lutherice.jpg'),
  mbrown: require('./Logos/mbrown.jpg'),
  merCer: require('./Logos/merCer.png'),
  middlega: require('./Logos/middlega.jpg'),
  morehouse: require('./Logos/morehouse.jpg'),
  ogletho: require('./Logos/ogletho.jpg'),
  painE: require('./Logos/painE.png'),
  piedmont: require('./Logos/piedmont.png'),
  pointga: require('./Logos/pointga.png'),
  reinhard: require('./Logos/reinhard.png'),
  savst: require('./Logos/savst.png'),
  scaD: require('./Logos/scaD.jpg'),
  shorter: require('./Logos/shorter.png'),
  sousava: require('./Logos/sousava.png'),
  spelman: require('./Logos/spelman.jpg'),
  thomasU: require('./Logos/thomasU.png'),
  toccoa: require('./Logos/toccoa.png'),
  truett: require('./Logos/truett.png'),
  Ugeorgia: require('./Logos/Ugeorgia.png'),
  UNgeorgia: require('./Logos/UNgeorgia.png'),
  UWgeorgia: require('./Logos/UWgeorgia.png'),
  valdosta: require('./Logos/valdosta.png'),
  youngharris: require('./Logos/youngharris.jpg'),
  albizu: require('./Logos/albizu.png'),
  avemaria: require('./Logos/avemaria.png'),
  barry: require('./Logos/barry.png'),
  beaconF: require('./Logos/beaconF.png'),
  bethunec: require('./Logos/bethunec.png'),
  buf: require('./Logos/buf.png'),
  dade: require('./Logos/dade.png'),
  dayflo: require('./Logos/dayflo.png'),
  eckerd: require('./Logos/eckerd.png'),
  edwater: require('./Logos/edwater.jpg'),
  ERAUf: require('./Logos/ERAUf.png'),
  famu: require('./Logos/famu.png'),
  fire: require('./Logos/fire.png'),
  flagler: require('./Logos/flagler.png'),
  flocollege: require('./Logos/flocollege.png'),
  flogulf: require('./Logos/flogulf.jpg'),
  floint: require('./Logos/floint.png'),
  flomemo: require('./Logos/flomemo.png'),
  flonat: require('./Logos/flonat.png'),
  flopoly: require('./Logos/flopoly.png'),
  floridaatl: require('./Logos/floridaatl.png'),
  flosouth: require('./Logos/flosouth.jpg'),
  flotech: require('./Logos/flotech.png'),
  hobe: require('./Logos/hobe.jpg'),
  hodges: require('./Logos/hodges.png'),
  irsc: require('./Logos/irsc.png'),
  jackflo: require('./Logos/jackflo.jpg'),
  jackuni: require('./Logos/jackuni.png'),
  johnvian: require('./Logos/johnvian.png'),
  lynn: require('./Logos/lynn.png'),
  miami: require('./Logos/miami.png'),
  newflori: require('./Logos/newflori.png'),
  novaflo: require('./Logos/novaflo.jpg'),
  palmbeac: require('./Logos/palmbeac.png'),
  pensacola: require('./Logos/pensacola.jpg'),
  ringling: require('./Logos/ringling.jpg'),
  santafe: require('./Logos/santafe.png'),
  schiller: require('./Logos/schiller.png'),
  seminole: require('./Logos/seminole.jpg'),
  spete: require('./Logos/spete.png'),
  stetson: require('./Logos/stetson.png'),
  sthomo: require('./Logos/sthomo.png'),
  stleo: require('./Logos/stleo.png'),
  talmudic: require('./Logos/talmudic.jpg'),
  threflo: require('./Logos/threflo.jpg'),
  triflori: require('./Logos/triflori.png'),
  UCflor: require('./Logos/UCflor.png'),
  Uflorida: require('./Logos/Uflorida.png'),
  UNflor: require('./Logos/UNflor.jpg'),
  USflor: require('./Logos/USflor.png'),
  utampa: require('./Logos/utampa.png'),
  Uwestflo: require('./Logos/Uwestflo.png'),
  valencia: require('./Logos/valencia.png'),
  weflo: require('./Logos/weflo.jpg'),
  

};

  return (
    <AppContext.Provider
      value={{
        greycol,
        backcol,
        texcol,
        saveColor,
        currentSort,
        setCurrentSort,
        UniList,
        setUniList,
        saveUniList,
        uninumber,
        setuninumber,
        uniname,
        setuniname,
        modalVisible,
        setModalVisible,
        open,
        setOpen,
        selectedStates,
        setSelectedStates,
        pickedstates,
        setpickedstates,
        csscheckbox,
        setcsscheckbox,
        rollingcheckbox,
        setrollingcheckbox,
        tutionmin,
        settutionmin,
        tuitionmax,
        settuitionmax,
        maximumaccept,
        setmaximumaccept,
        minimumaccept,
        setminimumaccept,
        logos
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
